import { UserRole } from "@/types/users";

export const Permissions = {
  Projects: {
    View: "projects:view",
    Create: "projects:create",
    Update: "projects:update",
    Delete: "projects:delete",
    Pay: "projects:pay",
    Convert: "projects:convert",
    ManageMembers: "projects:manage_members",
  },
  Properties: {
    View: "properties:view",
    Create: "properties:create",
    Update: "properties:update",
  },
  Companies: {
    View: "companies:view",
    Create: "companies:create",
    Update: "companies:update",
  },
  Clients: {
    View: "clients:view",
    Invite: "clients:invite",
    Update: "clients:update",
  },
  Calendar: {
    View: "calendar:view",
  },
  Users: {
    View: "users:view",
  },
} as const;

const AllPermissions = Object.values(Permissions).flatMap((resource) =>
  Object.values(resource),
);

export type IPermission = (typeof AllPermissions)[number];

export const RolePermissions: Record<UserRole, Set<IPermission>> = {
  [UserRole.SuperAdmin]: new Set([
    Permissions.Projects.View,
    Permissions.Projects.Create,
    Permissions.Projects.Update,
    Permissions.Projects.ManageMembers,
    Permissions.Properties.Create,
    Permissions.Properties.Update,
    Permissions.Companies.Create,
    Permissions.Companies.Update,
    Permissions.Clients.View,
    Permissions.Clients.Invite,
    Permissions.Clients.Update,
    Permissions.Calendar.View,
  ]),

  [UserRole.Admin]: new Set([
    Permissions.Projects.View,
    Permissions.Projects.Create,
    Permissions.Projects.Update,
    Permissions.Projects.ManageMembers,
    Permissions.Projects.Convert,
    Permissions.Projects.Delete,
    Permissions.Properties.View,
    Permissions.Properties.Create,
    Permissions.Properties.Update,
    Permissions.Companies.View,
    Permissions.Companies.Create,
    Permissions.Companies.Update,
    Permissions.Clients.View,
    Permissions.Clients.Invite,
    Permissions.Clients.Update,
    Permissions.Calendar.View,
    Permissions.Users.View,
  ]),

  [UserRole.ProjectManager]: new Set([
    Permissions.Projects.View,
    Permissions.Projects.Create,
    Permissions.Projects.Update,
    Permissions.Projects.Delete,
    Permissions.Projects.Pay,
    Permissions.Projects.Convert,
    Permissions.Projects.ManageMembers,
    Permissions.Properties.Create,
    Permissions.Properties.Update,
    Permissions.Companies.Create,
    Permissions.Companies.Update,
    Permissions.Clients.View,
    Permissions.Clients.Invite,
    Permissions.Clients.Update,
    Permissions.Calendar.View,
  ]),

  [UserRole.LoanOfficer]: new Set([
    Permissions.Projects.View,
    Permissions.Projects.Create,
    Permissions.Projects.Update,
    Permissions.Projects.ManageMembers,
    Permissions.Properties.Create,
    Permissions.Properties.Update,
    Permissions.Clients.View,
    Permissions.Calendar.View,
  ]),

  [UserRole.LoanProcessor]: new Set([
    Permissions.Projects.View,
    Permissions.Properties.Create,
    Permissions.Properties.Update,
    Permissions.Clients.View,
    Permissions.Calendar.View,
  ]),

  [UserRole.Inspector]: new Set([
    Permissions.Projects.View,
    Permissions.Projects.Update,
    Permissions.Clients.View,
    Permissions.Calendar.View,
  ]),

  [UserRole.Contractor]: new Set([
    Permissions.Projects.View,
    Permissions.Calendar.View,
  ]),

  [UserRole.Client]: new Set([
    Permissions.Projects.View,
    Permissions.Projects.Pay,
    Permissions.Projects.Convert,
    Permissions.Clients.View,
    Permissions.Calendar.View,
  ]),
};
